import { ServerErrorCode } from 'APP/restApi';
import { GroupServerErrorCode } from 'APP/restApi/constants/group.errors';

export const KNOWN_ERROR: Record<string, string> = {
  [GroupServerErrorCode.GroupDoesNotExist]: 'common_chat_is_not_accessible',
  [ServerErrorCode.HasNoPermissionsToPerformAction]: 'no_permission_alert',
  [GroupServerErrorCode.UserIsNotBannedInTheGroup]: 'common_group_alert_user_not_ban',
  [GroupServerErrorCode.UserIsBannedInTheGroup]: 'common_group_alert_user_ban',
  [GroupServerErrorCode.UserGroupRelationshipDoesNotExist]:
    'common_group_alert_relationship_not_exit',
  [GroupServerErrorCode.InvitationsTooManyToRemove]: 'common_group_alert_user_many_remove',
  [ServerErrorCode.HasNoPermissionToRemoveSpaceOwner]: 'space_admin_kick_owner_alert',
  [GroupServerErrorCode.ParticipantNotInGroup]: 'common_group_alert_member_not_group',
  [ServerErrorCode.UserIsNotSpaceManager]: 'space_admin_ownership_alert',
  [ServerErrorCode.SpaceDoesNotExist]: 'common_group_alert_space_not_exit',
  [GroupServerErrorCode.InvitationsToManyAdminsToAdd]: '',
};
